import * as React from "react";
import { FormattedMessage } from "react-intl";

export const maxCharacters = (amount = 140) => <FormattedMessage id="maxCharacters" values={{ amount }} />;
